import store from "@/store"
import { PlacementTypes } from "./types/Graphics.t";

type SvgInHtml = HTMLElement & SVGGraphicsElement;
/**
 * It takes in a SVG string and a placement type and returns the string wrapped in a group with style transformations applied.
 * the style transformation are assigned in the GDM for each graphic's product placement
 * @param {string} svg - the svg string
 * @param {PlacementTypes} [placement=graphic_sleeve_left] - The placement of the graphic.
 * @returns The SVG with the transform applied.
 */
export const TransformWrapper = (svg: string, placement: PlacementTypes = 'graphic_sleeve_left') => {

    const transform: Partial<CSSStyleDeclaration> = (<any>store.state).recipe?.recipe_v2?.components?.[placement]?.toolkit_options?.transform

    if (!transform) return svg

    const g: SvgInHtml = document.createElement('g') as SvgInHtml
    for (var prop in transform) {
        g.style[prop] = transform[prop] as string
    }
    g.innerHTML = svg
    return g.outerHTML
}

export default TransformWrapper
